import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { AppTab } from '@okcargo-apps/shared-domain-ionic';

@Component({
  selector: 'lib-freight-available-card-go-to-list-cta',
  templateUrl: './freight-available-card-go-to-list-cta.component.html',
  styleUrls: ['./freight-available-card-go-to-list-cta.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IonCardContent,
    IonButton,
    IonCardSubtitle,
    IonCardTitle,
    IonCardHeader,
    IonCard,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
  ],
})
export class FreightAvailableCardGoToListCtaComponent {
  protected AppTab = AppTab;

  // constructor() {}
}
